import { Outlet } from 'react-router-dom'

// css
import './LoginLayout.css'

const LoginLayout = () => {
    return (
        <div className="login-wrapper">
            <div className="video-background">
                <video
                    src="https://pms-bucket123.s3.amazonaws.com/Login_Screen_Bg_1774858779.mp4"
                    autoPlay
                    loop
                    muted
                    playsInline
                />
            </div>

            <div className="login-content">
                <Outlet />
            </div>
        </div>
    )
}

export default LoginLayout
